import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";

type TickCircleIconProps = Partial<SVGIconProps>;

const TickCircleIcon = ({ fill }: TickCircleIconProps) => {
  return (
    <SVGIcon fill="none" height="32" viewBox="0 0 33 32" width="33">
      <path
        d="M16.4993 2.66602C9.15268 2.66602 3.16602 8.65268 3.16602 15.9993C3.16602 23.346 9.15268 29.3327 16.4993 29.3327C23.846 29.3327 29.8327 23.346 29.8327 15.9993C29.8327 8.65268 23.846 2.66602 16.4993 2.66602ZM22.8727 12.9327L15.3127 20.4927C15.126 20.6793 14.8727 20.786 14.606 20.786C14.3393 20.786 14.086 20.6793 13.8993 20.4927L10.126 16.7193C9.73935 16.3327 9.73935 15.6927 10.126 15.306C10.5127 14.9193 11.1527 14.9193 11.5393 15.306L14.606 18.3727L21.4593 11.5193C21.846 11.1327 22.486 11.1327 22.8727 11.5193C23.2593 11.906 23.2593 12.5327 22.8727 12.9327Z"
        fill={fill ?? "#4ABE82"}
      />
    </SVGIcon>
  );
};

export default TickCircleIcon;
